import React, { useState } from "react";
import Navbar from "../../commonComponents/Navbar";
import Footer from "../../commonComponents/Footer";
import PlanYourNextEvent from "../../Componentsss/M.I.C.E.Solutions/PlanYouNextEvent/Planyournextevent";
import WhyChooseMIICE from "../../Componentsss/M.I.C.E.Solutions/WhyChooseM.I.C.E/WhyChooseMIICE";
import Industries from "../../Componentsss/M.I.C.E.Solutions/IndustriesWeWorkWith/IndustriesWeWork";
import WhyChooseBlueberryMIICE from "../../Componentsss/M.I.C.E.Solutions/WhyChooseBlueberryMICE/WhyChooseBlueberryMIICE";
import MIICESolutionBanner from "../../Componentsss/M.I.C.E.Solutions/MICESolutinBanner/MIICEsolutionBanner";
import OurMIICESolution from "../../Componentsss/M.I.C.E.Solutions/OURM.I.C.E.Solutions/OURMIICESolution";
import PopularDestinations from "../../Componentsss/M.I.C.E.Solutions/PopularDestination/Populardestination";

const MIICESolution = () => {
  const [bannerLoaded, setBannerLoaded] = useState(false);

  return (
    <>
      {bannerLoaded && <Navbar />}
      <MIICESolutionBanner onLoad={() => setBannerLoaded(true)} />
      {bannerLoaded && (
        <>
          <OurMIICESolution />
          <WhyChooseBlueberryMIICE />
          <PopularDestinations />
          <WhyChooseMIICE />
          <Industries />
          <PlanYourNextEvent />
          <Footer />
        </>
      )}
    </>
  );
};

export default MIICESolution;
